module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm2_m_en.8dc63c17308a7e3a888830c155e09713.png";